import React from 'react';
import { gql } from '@soundxyz/gql-string';
import { UserActivityDetail } from '@components/Feed/User/UserActivityDetail';
import { ComponentContainer, ComponentWrapper } from '@components/Feed/shared';
import { PlaylistPreview } from '@components/Playlists/Preview';
import type { FragmentType } from '@graphql/reactQuery';
import { getFragment, ReleasesLikedFragmentDoc } from '@graphql/reactQuery';

/*#__PURE__*/ gql(/* GraphQL */ `
  fragment ReleasesLiked on UserLikedSongsAggregate {
    releasesLiked {
      id
    }
    shelf {
      id
      ...PlaylistPreview
    }
    user {
      id
      ...UserActivityDetail
    }
    ...PlaylistNewReleasesLiked
  }
`);

export const NewLikedReleases = ({
  activityFrag,
  timeStamp,
}: {
  activityFrag: FragmentType<ReleasesLikedFragmentDoc>;
  timeStamp: number;
}) => {
  const activity = getFragment(ReleasesLikedFragmentDoc, activityFrag);

  const { shelf: playlist, releasesLiked, user } = activity;

  // TO DO: move to helper and add test https://linear.app/sound/issue/ENG-3309/[ui]-tests-refactor-main-feed-components-subtext-to-be-moved-to-a
  const releasesCount = releasesLiked.length;
  const subText = releasesCount === 1 ? 'liked a song ' : `liked ${releasesCount} songs`;

  return (
    <ComponentContainer>
      {!!timeStamp && !!user && (
        <UserActivityDetail user={user} subText={subText} createdAt={timeStamp} />
      )}
      <ComponentWrapper onlyMargin>
        {!!playlist && !!activity && (
          <PlaylistPreview playlistFrag={playlist} newLikedReleasesFrag={activity} />
        )}
      </ComponentWrapper>
    </ComponentContainer>
  );
};
